import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { parseISO } from 'date-fns';
import { useDispatch } from 'react-redux';
import { NoDataComponent, TwoGridSkeleton } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/common';
import { FormContainer, Separator } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/styles';
import { StyledTypography } from 'styles/common';

import { convertDateToString4 } from 'constants/helper';

import { getSettings } from 'services/engagement';
import { showErrorSnackbar } from 'services/snackbar';

const getDisplayData = (data) => {
  const startDate = data.startDate ? parseISO(data.startDate.split('T')[0]) : null;
  const endDate = data.endDate ? parseISO(data.endDate.split('T')[0]) : null;

  return {
    Privacy: data.isAnonymous
      ? "Participant's responses will be submitted anonymously"
      : "Participant's responses will be signed",
    Visibility: data.isPublic ? 'Survey result will be shared publicly' : 'Survey result will not be shared publicly',
    'Start date': startDate ? convertDateToString4(startDate) : '',
    'End date': endDate ? convertDateToString4(endDate) : '',
  };
};

const SettingsSummary = ({ formId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = () => {
    getSettings({ surveyId: formId })
      .then((res) => setData(res))
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to fetch the reminders!'));
      })
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const displayData = data ? getDisplayData(data) : null;

  return (
    <FormContainer>
      <StyledTypography color="#333" weight={600}>
        Survey Settings
      </StyledTypography>
      <Separator />
      {loading ? (
        <TwoGridSkeleton />
      ) : (
        <>
          {displayData ? (
            Object.keys(displayData).map((key, i) => (
              <>
                <Grid container>
                  <Grid xs={6}>
                    <StyledTypography color="#888">{key}</StyledTypography>
                  </Grid>
                  <Grid xs={6}>
                    <StyledTypography color="#333">{displayData[key]}</StyledTypography>
                  </Grid>
                </Grid>
                {i < Object.keys(displayData).length - 1 && <Separator />}
              </>
            ))
          ) : (
            <NoDataComponent />
          )}
        </>
      )}
    </FormContainer>
  );
};

export default SettingsSummary;
